import React, {Component, createRef } from 'react'
import Result from './Result_ho'
import './mySticky_ho.css'
import moment from  'moment-timezone'
//import { getResults } from '../reducers/resultReducer'
//import { toggleImportanceOf } from '../reducers/resultReducer'
//        <Table.HeaderCell textAlign="left" colSpan={`${searchColSpan}`}>53. PIRKAN HÖLKKÄ 2023/43. Pirkan Kierros<p>4. Pirkan Kieppi</p></Table.HeaderCell>
//        <Table.HeaderCell textAlign="left" colSpan={`${searchColSpan}`}>45. Pirkan Soutu<p>29.7.2023</p></Table.HeaderCell>
import { fetchAllResults, filterChangeSeries ,filterChangeSeura, filterChangeLahto,
  filterChangeSija, filterChangeMaali, filterChangeEro, filterChangeHaku, filterChangeKerrat, sortChangeMaali, sortChangeSarja } from '../actions/index'
import { Table, Segment, Input,Button , Icon, Sticky, Ref, Rail, Grid } from 'semantic-ui-react'

const Results = ({ store }) => {
  const { ver, lastver, results, extUrl, filterseries, filterseura, filterlahto,
     filtersija, filtermaali, filterero, filterhaku, filterkerrat, sortmaali, sortsarja } = store.getState()
  console.log ('Results: ',ver,lastver,filterseries,filterseura,filterlahto,filtersija,filtermaali,filterero,
  filterhaku,filterkerrat,sortmaali,sortsarja)
 // if (!lastver || ver !== lastver) {
 //   store.dispatch(fetchLastver(ver))
 // }
//
 // }
//console.log(results)

  const resultsToShowSeries = () => {
    if (filterseries !== 0 ){
      return results.filter(result => result.seriesno === filterseries)
    }
    else {
      return results
    }
  }

  const resultsToShowSeura = (resrecords) => {
    if (filterseura !== '' ) {
      return resrecords.filter(result => result.organization === filterseura)
    }
    else {
      return resrecords
    }
  }

  const resultsToShowLahto = (resrecords) => {
    if (filterlahto !== '' ) {
      return resrecords.filter(result => result.starttime === filterlahto)
    }
    else {
      return resrecords
    }
  }

  const resultsToShowSija = (resrecords) => {
    if (filtersija !== 0) {
      return resrecords.filter(result => result.space <= filtersija)
    }
    else {
      return resrecords
    }
  }
  const resultsToShowHaku = (resrecords) => {
    if (filterhaku !== '') {
      return resrecords.filter(result => (result.joukkue.toUpperCase().indexOf(filterhaku.toUpperCase()) > -1 && isNaN(filterhaku) === true) || 
      (result.organization.toUpperCase().indexOf(filterhaku.toUpperCase()) > -1  && isNaN(filterhaku) === true) ||
      (result.seriesname.toUpperCase().indexOf(filterhaku.toUpperCase()) > -1  && isNaN(filterhaku) === true) || 
      result.number.toString() === filterhaku )
    }
    else {
      return resrecords
    }
  }
  const resultsToShowKerrat = (resrecords) => {
    if (filterkerrat !== '') {
      return resrecords.filter(result => result.kerrat === filterkerrat)
    }
    else {
      return resrecords
    }
  }

  const resultsToShowMaali= (resrecords) => {
    if (filtermaali !== '') {
      return resrecords.filter(result => result.eventtime >= filtermaali)
    }
    else {
      return resrecords
    }
  }

  const cEro=filterero !=='' ? 'Ero' : 'Ero'

  const handleSortClick = sortColumn => () => {
    if (sortColumn ==='Maali') {
       store.dispatch(sortChangeMaali(sortmaali === 'descending' ? 'ascending' : 'descending'))}
    else if (sortColumn ==='Sarja') {
      store.dispatch(sortChangeSarja(sortsarja === 'ascending' ? '' : 'ascending'))}
   }


  const sortResults = () => {
    
    console.log('sorting',sortsarja,sortmaali)
    if ((sortmaali === 'ascending') && (sortsarja === 'ascending')) {
      return (
      function(a,b){ if((a.eventtime < b.eventtime && a.seriesname == b.seriesname) || (a.seriesname < b.seriesname)) {
          return -1;
          }
      if((a.eventtime > b.eventtime && a.seriesname == b.seriesname)  || (a.seriesname > b.seriesname)) {
        return 1;
        }
      return 0;
      }
    )}
    if ((sortmaali === 'descending') && (sortsarja === 'ascending')) {
        return (
          function(a,b){ if((a.eventtime > b.eventtime && a.seriesname == b.seriesname) || (a.seriesname < b.seriesname)) {
              return -1;
              }
          if((a.eventtime < b.eventtime && a.seriesname == b.seriesname)  || (a.seriesname > b.seriesname)) {
            return 1;
            }
          return 0;
          }
        )}
    else if (sortmaali === 'ascending') {
      return (
      function(a,b){ if(a.eventtime < b.eventtime) {
          return -1;
          }
      if(a.eventtime > b.eventtime) {
        return 1;
        }
      return 0;
      }
    )}
    else {
    return (  
      function(a,b){ if(a.eventtime > b.eventtime) {
          return -1;
          }
      if(a.eventtime < b.eventtime) {
        return 1;
        }
      return 0;
      })
    }  
   }

  const cSeura= filterseura !== '' ? {style: {color: 'red' }} : {}
  const cAika= filterlahto !== '' ? {style: {color: 'red' }} : {}
  const cSija= filtersija !== 0 ? {style: {color: 'red' }} : {}
  const cSarja= filterseries !== 0 ? {style: {color: 'red' }} : {}
  const cSarjasort= sortsarja === 'ascending' ? 'sort up' : 'sort'
  const cKerrat= filterkerrat !== '' ? {style: {color: 'red' }} : {}
  const cMaali= filtermaali !== '' ? {style: {color: 'red' }} : {color: 'black'}
  const cMaalisort= sortmaali === 'ascending' ? 'sort up' : 'sort down'

  const fLahto= filterlahto !== '' ? 'Läh '+filterlahto.substr(11,5) : ''
  const fSija= filtersija !== 0 ? '<='+filtersija : ''
  const fKerrat= filterkerrat !== '' ? '='+filterkerrat : ''
  const inputRef = createRef()
  const handleClick = () => (
    inputRef.current.focus(),
    store.dispatch(filterChangeHaku(''))
  )
  const handleDefaultClick = () =>(
    store.dispatch(StoreDefaults())
  )
  const StoreDefaults = () => dispatch => {
    return Promise.all([
    dispatch(filterChangeHaku('')),
    dispatch(filterChangeSeries(0)),
    dispatch(filterChangeSeura('')),
    dispatch(filterChangeLahto('')),
    dispatch(filterChangeMaali('')),
    dispatch(filterChangeEro('')),
    dispatch(filterChangeKerrat('')),
    dispatch(filterChangeSija(0)),
    dispatch(sortChangeMaali('descending')),
    dispatch(sortChangeSarja(''))]
    )
  }
  const SearchButtonText= filterhaku ? "Poista Haku" : "Haku"  
  const searchColSpan=filterero !== "ALL" ? "4" : "5"
  const contextRef = createRef()




  return(


    <Table  celled unstackable structured compact sortable selectable >  

      <Table.Header>  
        <Table.Row>
        <Table.HeaderCell colSpan="2">   
          <Input ref={inputRef} size="small" type="text"  placeholder="Haku..." icon='search'  id="search_form"
            value={filterhaku}
            onChange={ (event) => store.dispatch(filterChangeHaku(event.target.value))}>
            </Input>
            <Button content={SearchButtonText} compact onClick={handleClick}></Button>
        </Table.HeaderCell>
        <Table.HeaderCell textAlign="left" colSpan={`${searchColSpan}`}>56. PIRKAN HÖLKKÄ 2026/46. Pirkan Kierros<p>7. Pirkan Kieppi</p></Table.HeaderCell>
        <Table.HeaderCell textAlign="center" colSpan="2"><Button color='green' content="Online" compact onClick={handleDefaultClick}>Palaa<p>Online</p></Button></Table.HeaderCell>
        </Table.Row>


        <Table.Row >

          <Table.HeaderCell>Numero</Table.HeaderCell>
          <Table.HeaderCell>Nimi (kerrat)</Table.HeaderCell>
          <Table.HeaderCell {...cSeura}>Seura</Table.HeaderCell>
          <Table.HeaderCell {...cAika} textAlign="right">Aika<p>{fLahto}</p></Table.HeaderCell>
          <Table.HeaderCell {...cSija} textAlign="right">Sija<p>{fSija}</p></Table.HeaderCell>
          <Table.HeaderCell {...cSarja} onClick={handleSortClick("Sarja")}>Sarja  <Icon name={cSarjasort} /></Table.HeaderCell>
          { filterero !== "ALL"
          ? <><Table.HeaderCell textAlign="right" onClick={ () => store.dispatch(filterChangeEro(filterero === '' ? 'ALL' : ''))}>{cEro}</Table.HeaderCell></>
          : <><Table.HeaderCell textAlign="right" onClick={ () => store.dispatch(filterChangeEro(''))}>Ero</Table.HeaderCell>
          <Table.HeaderCell textAlign="right" onClick={ () => store.dispatch(filterChangeEro(''))}>Ero ed</Table.HeaderCell></>
          }
          <Table.HeaderCell {...cMaali} onClick={handleSortClick("Maali")}>Maali  <Icon name={cMaalisort} /></Table.HeaderCell> 
        </Table.Row>                 
      </Table.Header>   

      <Ref innerRef={contextRef}>
      <Table.Body>
        {resultsToShowLahto(resultsToShowSeura(resultsToShowSija(resultsToShowMaali(resultsToShowKerrat(resultsToShowHaku(resultsToShowSeries())))))).sort(sortResults()).map(result =>
          <Result
            key={result.id}
            result={result}
            ver={ver}
            lastver={lastver}
            extUrl={extUrl}
            filterseries={filterseries}
            filterseura={filterseura}
            filterlahto={filterlahto}
            filtersija={filtersija}
            filterero={filterero}
            filterhaku={filterhaku}
            store={store}
            handleClick={() => store.dispatch(fetchAllResults())}
            handleSeriesClick={ () => store.dispatch(filterChangeSeries(filterseries=== 0 ? result.seriesno : 0))}
            handleSeuraClick={ () => store.dispatch(filterChangeSeura(filterseura === '' ? result.organization : ''))}
            handleLahtoClick={ () => store.dispatch(filterChangeLahto(filterlahto === '' ? result.starttime : ''))}
            handleMaaliClick={ () => store.dispatch(filterChangeMaali(filtermaali === '' ? result.eventtime :
                                        (result.eventtime !== filtermaali ? result.eventtime : '')))}
            handleEroClick={ () => store.dispatch(filterChangeEro(filterero === '' ? 'ED' : ''))}
            handleKerratClick={ () => store.dispatch(filterChangeKerrat(filterkerrat === '' ? result.kerrat : ''))}
            handleSijaClick={ () => store.dispatch(filterChangeSija(filtersija === 0 ? result.space : 0))}>
          </Result> 
        )}
        <Segment style={{ minHeight: "120vh" }}  compact ></Segment> 
      </Table.Body>
      </Ref>
    </Table>
 
  )
}

export default Results
